














import { computed, defineComponent } from '@vue/composition-api';

import packageUnits from '@/components/Delivery/packageUnit';

const CommonUnitSelector = defineComponent({
  setup(props: any) {
    const _value = computed(() => props.value);

    return {
      _value,
      packageUnits,
    };
  },
  props: {
    level: {},
    label: {
      type: String,
      default() { return 'หน่วย'; },
    },
    value: {
      type: String,
      default() { return ''; },
    },
    showLabel: { default: true },
    rules: { default: '' },
  },
});

export default CommonUnitSelector;
